import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { TicketAssignmentMasterComponent } from './ticket-assignment-master.component';

const routes: Routes = [
  {
    path: 'ticket-assignment-page',
    component: TicketAssignmentMasterComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TicketAssignmentMasterRoutingModule {}
